import React from "react";
import './AmountField.css';
import './AmountFieldPhone.css';
import {remFromPx} from "../../../services/utils/ui-commons";
import ReactInput from "../../../services/packages/input-format/react/Input";
import {currencyFormat} from "../../../services/utils/numberFormatter";
import parseDigit from "../../../services/packages/input-format/parseDigit";
import {PLEDGER_GREEN_COLOR} from "../../../services/utils/colors";


const formatAmountValue =  value => {
    let text = '';

    const valueNumber = value==='' ? NaN  : Number(value);
    if (!isNaN(valueNumber)) {
        text = currencyFormat(valueNumber,'fr-FR',  {
            maximumFractionDigits:2,
            minimumFractionDigits:0,
            style:'currency',
            currency:'EUR'});
        if (value.indexOf('.')===(value.length-1)) {
            text=text.substr(0,text.length-2)+','+text.substr(text.length-2,2);
        }
    }

    return { text, template: '',editableLength:text.length-2 }
}


export const roundedAmountValueFormatter = value => {
    let text = '';

    const valueNumber = value === '' ? NaN : Number(value);
    if (!isNaN(valueNumber)) {
        text = currencyFormat(valueNumber, 'fr-FR', {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
            style: 'currency',
            currency: 'EUR'
        })
            .replace(new RegExp(String.fromCharCode(8239), 'g'), ' ')
            .replace(new RegExp(String.fromCharCode(160), 'g'), ' ')
            .replace(new RegExp(String.fromCharCode(8364), 'g'), '')
            .trim();
    }
    return {text, template: '', editableLength: text.length}
};



/**
 * `input-format` `parse()` function.
 * https://github.com/catamphetamine/input-format
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string} value - The value parsed so far.
 * @param  {object} meta - Optional custom use-case-specific metadata.
 * @return {string?} The parsed character.
 */
function parseAmountCharacter(character, value)
{
    // Allow digits.
    if (character === ',' || character==='.') {
        if (value.indexOf('.') >= 0) {
            return
        }
        return '.';
    }
    return parseDigit(character)
}

/**
 * Input field for currency amount
 */
export class AmountField extends React.Component {

    constructor(props) {
        super(props);
        this.valueFormatter = this.props.valueFormatter === undefined ? formatAmountValue : this.props.valueFormatter;
        this.state = {
            formattedText: ''
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const formattedValue = this.valueFormatter(this.props.state);
        const formattedText = formattedValue.text;
        let selectionPosition = 0;

        selectionPosition = formattedValue.editableLength;
        if ((prevProps.focus !== this.props.focus) || (!this.focusSet)) {
            if (this.props.focus) {
                this.inputRef.focus();

                 // setTimeOut Obligatoire sous Android
                setTimeout(() => {
                        const inputRef = this.inputRef;
                        if (inputRef !== null) {
                            inputRef.setSelectionRange(selectionPosition, selectionPosition);
                        }
                    }
                    , 5);

                //  this.inputRef.input.selectionStart = this.inputRef.input.selectionEnd = selectionPosition;
            }
        }
        this.focusSet = true;

        if (formattedText !== this.state.formattedText) {
            // on force le curseur à la fin de la zone de saisie : le timeout permet de contourner un bug dans Android
            setTimeout(() => {
                if (null!==this.inputRef) {
                    this.inputRef.setSelectionRange(selectionPosition, selectionPosition)
                }
            }, 5);
            this.setState({...this.state, formattedText});
        }


    }

    render() {
        const context = this.props.context;
        const state = this.props.state;
        const textAlign = this.props.textAlign===undefined ? 'right' : this.props.textAlign;
        const isPhone = context.appContext.isPhone;

        const fontSize = this.props.fontSize === undefined ? remFromPx(26) : this.props.fontSize;
        const fontVariationSettings = this.props.fontVariationSettings === undefined ? 400 : this.props.fontVariationSettings;
        const width = this.props.width === undefined ? '100%' :  this.props.width;
        const paddingRight  = this.props.paddingRight === undefined ? remFromPx(15) :  this.props.paddingRight;
        const style = {
         //   borderBottom: this.props.enabled ? '1px solid #002538' : '1px solid #8C8C8C',
            width: width,
            //height: '100%'
        };

        const inputStyle = {
            fontFamily: 'WorkSansVariableFont',
            fontSize: fontSize,
            fontVariationSettings: `'wght' ${fontVariationSettings}`,
            backgroundColor: 'transparent',
            borderStyle: 'none',
            width: '100%',
            outline: 'none',
            margin: 0,
            paddingRight: paddingRight,
            textAlign: textAlign,
            color: this.props.color !== undefined ? this.props.color : PLEDGER_GREEN_COLOR
        };

        const onInputRef = (input) => {
            this.inputRef = input;
        };

        const onChange = value => {
            context.dispatch(this.props.createOnChangeAction(value));
        };

        const onFocus = (e) => {
            if (this.props.onFocusAction) {
                context.dispatch(this.props.onFocusAction);
            } else {
                if (this.props.onFocus) {
                    this.props.onFocus();
                }
            }

        };

        this.focusSet = false;

        const readonly = this.props.readonly !== undefined ? this.props.readonly : false;
        const inputClass = this.props.inputClass !== undefined ? this.props.inputClass : (isPhone ? 'AmountInputClassPhone' : 'AmountInputClass');

        return (
            <div style={style}>
                <ReactInput className={inputClass}
                            style={inputStyle}
                            type={'text'}
                            pattern={isPhone ? '[0-9]*' : undefined}
                            inputMode={isPhone ? 'numeric' : undefined}
                            value={''+state}
                            placeholder={this.props.placeholder}
                            ref={onInputRef}
                            onFocus={onFocus}
                            onChange={onChange}
                            disabled={!this.props.enabled}
                            readOnly={readonly}
                            parse={parseAmountCharacter}
                            format={this.valueFormatter}/>
            </div>
        );
    }
}
